import React from 'react'
import { Icon, Text } from '@/components'
import { createStyles } from '@codeleap/styles'
import { Chat } from '@/config'

export const ChatToast = () => {
  const toastMessage = Chat.Store.state.use(s => s.toastMessage)
  const [isVisible, setIsVisible] = React.useState(false)
  const [shouldRender, setShouldRender] = React.useState(false)
  const [displayMessage, setDisplayMessage] = React.useState('')

  React.useEffect(() => {
    if (toastMessage) {
      setDisplayMessage(toastMessage)
      setShouldRender(true)
      setTimeout(() => setIsVisible(true), 10)
    } else if (shouldRender) {
      setIsVisible(false)
      const timeout = setTimeout(() => {
        setShouldRender(false)
      }, 500)
      return () => clearTimeout(timeout)
    }
  }, [toastMessage, shouldRender])

  if (!shouldRender) return null

  return (
    <div
      style={{
        ...styles.wrapper,
        ...(isVisible ? styles.wrapperVisible : styles.wrapperHidden),
      }}
      className={'chat-toast'}
    >
      <Icon name='check-circle' style={styles.icon} />
      <Text text={displayMessage} style={styles.text} />
    </div>
  )
}

const WRAPPER_HEIGHT = 48

const styles = createStyles(theme => ({
  wrapper: {
    position: 'absolute',
    top: theme.spacing.value(-8),
    left: '50%',
    zIndex: 1000,
    backgroundColor: theme.colors.bgDefault,
    borderRadius: theme.radius.large,
    height: WRAPPER_HEIGHT,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: theme.effects.light.boxShadow,
    paddingLeft: theme.spacing.value(2),
    paddingRight: theme.spacing.value(2),
    transition: 'transform 0.5s ease-out, opacity 0.5s ease-out',
  },
  wrapperVisible: {
    transform: 'translateX(-50%) translateY(0)',
    opacity: 1,
  },
  wrapperHidden: {
    transform: 'translateX(-50%) translateY(100%)',
    opacity: 0,
  },
  icon: {
    width: theme.size.medium,
    height: theme.size.medium,
    fontSize: theme.size.medium,
    color: theme.baseColors.greenSolid600,
  },
  text: {
    marginLeft: theme.spacing.value(1),
    fontSize: 14,
    fontWeight: '500',
    color: theme.colors.textHeadingHighlighted,
  },
}))
